import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.5 5.42A4.92 4.92 0 0 1 11.42.5h.19c1.522 0 2.935.79 3.732 2.085l.115.187c1.097 1.782.756 3.903-.481 5.284a6.065 6.065 0 0 1 3.524 5.508 5.694 5.694 0 0 1-1.668 4.018 6.149 6.149 0 0 1-7.085 1.16L8.5 18.117V20A3.5 3.5 0 0 1 5 23.5v-2A1.5 1.5 0 0 0 6.5 20V5.42Zm2 10.462 2.141 1.07a4.148 4.148 0 0 0 4.777-.784 3.694 3.694 0 0 0 1.082-2.604A4.064 4.064 0 0 0 12.436 9.5H9.5v-2h2.45c1.766-.19 2.74-2.16 1.804-3.68l-.115-.187A2.382 2.382 0 0 0 11.61 2.5h-.19A2.92 2.92 0 0 0 8.5 5.42v10.462Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionBetatest24 = createIcon(IconComponent);